import axios from "axios"
import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useCallback,
} from "react"

import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Alert,
} from "@mui/material"
import WebService from "../util/webService"
import { encodeParams, getAction, printVariable } from "../util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Snackbar,
  TablePagination,
  TextField,
  withStyles,
  InputBase,
} from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "../components/FlatButton"
import useSnackbar from "../hooks/useSnackbar"
import MyTableHead from "../components/MyTableHead"
import useIndicator from "../hooks/useIndicator"
import Indicator from "../components/Indicator"
import MyDialog from "../components/MyDialog"
import useForm from "../hooks/useForm"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import Paper from "@mui/material/Paper"
import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
// date
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import "dayjs/locale/ko"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"
import { searchSchool } from "../util/helper"
import { schoolGrades } from "@util/schoolInfo"

const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`

const RLTN_CODE = "S003"
const LecturePage = () => {
  console.log("LecturePage rendering...")
  const g_sel_code = "SA07"
  const g_stat_code = "SA08"
  const g_week_code = "SB07"

  const inputRef = useRef()
  const defUrl = "/lecture"
  const dateFormat = "YYYY-MM-DD HH:mm:ss"
  const [detailScreen, set_detailScreen] = useState(false)
  const [smstList, set_smstList] = useState([])
  const [selCodeList, set_selCodeList] = useState([])
  const [statCodeList, set_statCodeList] = useState([])
  const [weekCodeList, set_weekCodeList] = useState([])
  const fields = [
    {
      field: "id",
      placeholder: "아이디",
      type: "text",
      value: -1,
      visible: false,
      canSrch: false,
      selList: [],
    },
    {
      field: "smstId",
      placeholder: "학교/년도/기수",
      type: "select",
      value: "",
      visible: detailScreen,
      canSrch: false,
      selList: smstList,
    },
    {
      field: "smstName",
      placeholder: "학교/년도/기수",
      type: "select",
      value: "",
      visible: !detailScreen,
      canSrch: false,
      selList: [],
    },
    {
      field: "userId",
      placeholder: "강사명",
      type: "select",
      value: -1,
      visible: detailScreen,
      canSrch: false,
      selList: [],
    },
    {
      field: "teacherName",
      placeholder: "강사명",
      type: "text",
      value: "",
      visible: !detailScreen,
      canSrch: false,
      selList: [],
    },
    {
      field: "title",
      placeholder: "강좌 제목",
      type: "text",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "weekCode",
      placeholder: "요일",
      type: "checkbox",
      value: "",
      visible: detailScreen,
      canSrch: false,
      selList: weekCodeList,
    },
    {
      field: "loc",
      placeholder: "위치",
      type: "text",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "rcrNum",
      placeholder: "모집인원",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "reqNum",
      placeholder: "신청인원",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "sttNum",
      placeholder: "수강인원",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "lfee",
      placeholder: "강의료",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "mfee",
      placeholder: "재료비",
      type: "number",
      value: "",
      visible: true,
      canSrch: false,
      selList: [],
    },
    {
      field: "selCode",
      placeholder: "선발방식",
      type: "select",
      value: "",
      visible: detailScreen,
      canSrch: false,
      selList: selCodeList,
    },
    {
      field: "selCodeName",
      placeholder: "선발방식",
      type: "select",
      value: "",
      visible: !detailScreen,
      canSrch: false,
      selList: selCodeList,
    },
    {
      field: "statCode",
      placeholder: "상태",
      type: "select",
      value: "",
      visible: detailScreen,
      canSrch: false,
      selList: statCodeList,
    },
    {
      field: "statCodeName",
      placeholder: "상태",
      type: "select",
      value: "",
      visible: !detailScreen,
      canSrch: false,
      selList: [],
    },
    {
      field: "regTime",
      placeholder: "등록일시",
      type: "text",
      value: "",
      visible: false,
      canSrch: false,
      selList: [],
    },
    {
      field: "uptTime",
      placeholder: "수정일시",
      type: "text",
      value: "",
      visible: false,
      canSrch: false,
      selList: [],
    },
    {
      field: "content",
      placeholder: "내용",
      type: "textarea",
      value: "",
      visible: detailScreen,
      canSrch: false,
      selList: [],
    },
  ]
  // const [fields, set_fields] = useState([...defFields])

  const gdnFields = [
    { field: "name", placeholder: "성명" },
    { field: "loginId", placeholder: "ID" },
    { field: "phone", placeholder: "전화번호" },
    { field: "phoneCertYn", placeholder: "인증여부" },
  ]

  const regiLectureFields = [
    { field: "title", placeholder: "강좌제목", table: "lecture" },
    {
      field: "statCode",
      placeholder: "강좌상태",
      table: "lecture",
      fn: (code) => findCode("SA09", code),
    },
    {
      field: "statCode",
      placeholder: "신청상태",
      table: "regi",
      fn: (code) => findCode("SA12", code),
    },
    {
      field: "regCode",
      placeholder: "등록상태",
      table: "regi",
      fn: (code) => findCode("SB12", code),
    },
  ]

  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })

  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ""))
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState([])

  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef(terms)
  const [smstGroup, set_smstGroup] = useState([])


  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const schola = useSelector((state) => state.scholaReducer)
  
  const defLschList = useMemo(() => {
    const lschList = []
    const lsch = {
      id: -1,
      lectureId: -1,
      weekCode: "-1",
      startTime: null,
      endTime: null,
    }

    codes
      .filter((c) => c.codeGroupId === g_week_code)
      .forEach((w) => {
        lschList.push({ ...lsch, weekCode: w.code })
      })

    return lschList
  })

  const ltgList = useMemo(() => {
    const ltgList = []
    const ltg = {
      id: -1,
      lectureId: -1,
      grade: -1,
    }
    const grades = schoolGrades[schola?.id] ?? [1,2,3,4,5,6]
    for(const grade of grades) {
      ltgList.push({ ...ltg, grade: grade })
    }

    // for (let i = 1; i < 11; i++) {
    //   ltgList.push({ ...ltg, grade: i })
    // }
    return ltgList
  })


  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const onLoad = async () => {
    openIndicator()
    let url = `${defUrl}/extra`
    const newTerms = {}
    Object.keys(termsRef.current).forEach((key) => {
      if (termsRef.current[key] !== "") {
        newTerms[key] = termsRef.current[key]
      }
    })

    let tempList
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    })

    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const originList = JSON.parse(repMessage.records)
      const totalCount = repMessage.totalCount

      set_totalCount(totalCount)
      const records = originList.reduce((acc, cur, idx, arr) => {
        const lecture = cur.lecture
        lecture.teacherName = arr[idx].teacher.name
        lecture.userId = arr[idx].teacher.id
        acc.push(lecture)
        return acc
      }, [])

      records.forEach((r) => {
        r.isDetail = false
        r.weekCodeList = []
        r.lschList = defLschList
        r.ltgList = []
        r.attchs = []
      })

      // set_dataList(records)
      tempList = records
    }

    tempList.forEach((temp) => {
      const found = schools.find((d) => d.id === temp.schoolId)
      if (found) {
        temp.schoolId = found.id
        temp.schoolName = found.name
      }
    })

    // 학기
    url = "/smst"
    resp = await WebService.get(url, {})

    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach((r) => {
        const school = schools.find((s) => s.id === +r.schoolId)
        if (school) {
          r.name = `${school.name}/${r.year}/${r.gisu}`
        } 
      })
      records.unshift({ id: -1, name: "학교 기수 선택" })
      set_smstList(records)

      tempList.forEach((temp) => {
        const found = records.find((d) => d.id === temp.smstId)
        if (found) {
          temp.smstName = found.name
        }
      })
    }

    // 코드
    let records
    records = codes.filter((c) => c.codeGroupId === g_sel_code)
    records.forEach((r) => {
      r.id = r.code
    })
    records.unshift({ id: -1, name: "선발방식 선택" })
    set_selCodeList(records)
    tempList.forEach((temp) => {
      const found = records.find((d) => d.id === temp.selCode)
      if (found) {
        temp.selCodeName = found.name
      }
    })

    records = codes.filter((c) => c.codeGroupId === g_stat_code)
    records.forEach((r) => {
      r.id = r.code
    })
    records.unshift({ id: -1, name: "상태 선택" })
    set_statCodeList(records)
    tempList.forEach((temp) => {
      const found = records.find((d) => d.id === temp.statCode)
      if (found) {
        temp.statCodeName = found.name
      }
    })

    records = codes.filter((c) => c.codeGroupId === g_week_code)
    records.forEach((r) => {
      r.id = r.code
    })

    set_weekCodeList(records)

    // teacher list
    // url = '/user/school'
    // resp = await WebService.get(url, {rltnCode: RLTN_CODE})
    // if(resp.repCode === 'ack') {
    //   const repMessage = JSON.parse(resp.repMessage)
    //   const records = JSON.parse(repMessage.records)
    //   records.unshift({id:-1, name: '강사 선택'})
    //   set_teacherList(records)

    //   tempList.forEach(st => {
    //     const found = records.find(d => d.id === st.userId)
    //     if(found) {
    //       st.teacherName = found.name
    //     }
    //   })
    // }

    const smstGroup = tempList.reduce((acc, cur) => {
      if (acc[cur.smstId]) {
        acc[cur.smstId].push(cur)
      } else {
        acc[cur.smstId] = [cur]
      }
      return acc
    }, {})
    set_dataList(smstGroup)
    closeIndicator()
  }

  const onDetail = async (smstId, lectureId) => {
    let url
    let resp

    url = `${defUrl}/lsch/ltg`
    resp = await WebService.get(url, { lectureId: lectureId })
    if (resp.repCode === "ack") {
      const repMessage = JSON.parse(resp.repMessage)
      const lschs = JSON.parse(repMessage.lschs)
      const ltgs = JSON.parse(repMessage.ltgs)
      const attchs = JSON.parse(repMessage.attchs)
      attchs.forEach((f) => {
      })

      // set_files(attchs)
      const newDataList = { ...dataList }
      const lecture = newDataList[smstId].find((d) => d.id === lectureId)

      const tempWeekCodeList = []
      lschs.forEach((lsch) => {
        const weekCode = weekCodeList.find((w) => w.code === lsch.weekCode)
        tempWeekCodeList.push(weekCode)

        const localLsch = lecture.lschList.find(
          (lsch2) => lsch2.weekCode === lsch.weekCode
        )
        localLsch.startTime = `2000-01-01 ${lsch.startTime}:00`
        localLsch.endTime = `2000-01-01 ${lsch.endTime}:00`
      })

      lecture.weekCodeList = tempWeekCodeList

      // 학년
      lecture.ltgList = ltgs

      // 첨부
      lecture.attchs = attchs
      set_dataList(newDataList)
    }

    set_detailScreen(true)
    dgHandler[1](true)
  }

  const onSchedule = async (id) => { }

  const onDelete = async (id) => {
    const url = defUrl
    const resp = await WebService.delete(url, { id: id })
    if (resp.repCode === "ack") {
      onLoad()
      openSnackbar("삭제되었습니다.")
    } else {
      openSnackbar(resp.repMessage)
    }
  }

  const onCreate = () => {
    const now = moment().format(dateFormat)
    const newRecord = { ...defRecord, phase: 0, regTime: now, uptTime: now }
    newRecord.weekCodeList = []
    newRecord.lschList = defLschList
    newRecord.ltgList = []
    newRecord.attchs = []

    set_record(newRecord)
    set_detailScreen(true)
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach((k) => {
      obj[k] = ""
    })
    set_terms(obj)
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }

  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }



    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label='first page'>
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label='previous page'>
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='next page'>
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label='last page'>
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }

  const findCode = (codeGroupId, code) => {
    const found = codes
      .filter((d) => d.codeGroupId === codeGroupId)
      .find((d) => d.code === code)
    return found
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }))

  //
  const DgContent = () => {
    const xs = 12 / visibleColumns.length <= 3 ? 3 : 12 / visibleColumns.length
    const lschList = []
    const ltgList2 = []

    const onSubmit = async () => {
      if (activeRow.weekCodeList.length === 0) {
        openSnackbar("한 개 이상의 요일이 선택되어야 합니다.")
        return
      }
      var flag = true
      activeRow.weekCodeList.forEach((w) => {
        const found = activeRow.lschList.find(
          (lsch) => lsch.weekCode === w.code
        )
        if (found) {
          if (found.startTime === null || found.endTime === null) {
            flag = false
            return false
          }
          // TODO
          // 시간 전후 체크
        }
      })
      if (!flag) {
        openSnackbar("체크된 요일은 시작시간과 종료시간을 입력해야 합니다.")
        return
      }

      if (activeRow.ltgList.length === 0) {
        openSnackbar("한 개 이상의 학년을 체크해 주세요.")
        return
      }

      const temp = activeRow.lschList.filter(
        (lsch) => lsch.startTime !== null || lsch.endTime !== null
      )
      const datum1 = JSON.parse(JSON.stringify(temp))
      datum1.forEach((lsch) => {
        lsch.lectureId = activeRow.id
        lsch.startTime = moment(new Date(lsch.startTime)).format("HH:mm")
        lsch.endTime = moment(new Date(lsch.endTime)).format("HH:mm")
      })

      const datum2 = activeRow.ltgList
      datum2.forEach((ltg) => {
        ltg.lectureId = activeRow.id
      })

      const data = {
        lecture: JSON.stringify(activeRow),
        lschList: JSON.stringify(datum1),
        ltgList: JSON.stringify(datum2),
      }
      const formData = new FormData()

      files.forEach((file, index) => {
        if (file instanceof File) {
          // formData.append(`files`, file)
          const f = new File([file], file.name, { type: file.type })
          formData.append(`files`, f)
        }
      })

      const jsonData = JSON.stringify(data)
      formData.append(
        "body",
        new Blob([jsonData], { type: "application/json" })
      )

      const url = `${defUrl}/lsch/ltg`

      // use axios directly with config and
      /* spring take parameter like this,
        @RequestPart(value = "body", required = true) body: String,
        @RequestPart(value = "files", required = false) files: java.util.List[MultipartFile]
      */
      const resp = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      if (resp.data.repCode === "ack") {
        onLoad()
        handleChange()
        openSnackbar("저장되었습니다.")
      } else {
        openSnackbar("에러 발생")
      }

    }

    const onChangeWeek = async (weekCode, e) => {
      const week = weekCodeList.find((d) => d.id === weekCode)
      const found = activeRow.weekCodeList.find((d) => d.id === weekCode)
      if (found && !e.target.checked) {
        const idx = activeRow.weekCodeList.indexOf(found)
        activeRow.weekCodeList.splice(idx, 1)
        const lsch = activeRow.lschList.find(
          (lsch) => lsch.weekCode === weekCode
        )
        lsch.startTime = null
        lsch.endTime = null

        handleChange()
      }
      if (!found && e.target.checked) {
        activeRow.weekCodeList.push(week)
        handleChange()
      }
    }

    const onChangeGrade = async (grade, e) => {
      const ltg = ltgList.find((d) => d.grade === grade)
      const found = activeRow.ltgList.find((d) => d.grade === grade)
      if (found && !e.target.checked) {
        const idx = activeRow.ltgList.indexOf(found)
        activeRow.ltgList.splice(idx, 1)
        handleChange()
      }
      if (!found && e.target.checked) {
        activeRow.ltgList.push(ltg)
        handleChange()
      }
    }

    const validate = () => { }
    const [activeRow, errors, formLoading, handleChange, handleSubmit] =
      useForm({
        initialValues: { ...record },
        onSubmit: onSubmit,
        validate: validate,
      })

    const [emailError, setEmailError] = useState("")
    const [passwordState, setPasswordState] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [nameError, setNameError] = useState("")
    const [registerError, setRegisterError] = useState("")
    const [teacherList, _set_teacherList] = useState([])
    // const [files, set_files] = useState([activeRow.attchs])
    const [files, set_files] = useState([])

    // const Boxs = styled(Box)`
    //   padding-bottom: 40px !important;
    // `;

    const set_teacherList = async (smstId) => {
      const url = "/user/smst"
      const resp = await WebService.get(url, {
        smstId: smstId,
        rltnCode: "S003",
      })
      if (resp.repCode === "ack") {
        const repMessage = JSON.parse(resp.repMessage)
        const records = JSON.parse(repMessage.records)
        records.unshift({ id: -1, name: "강사선택" })
        _set_teacherList(records)
      } else {
        _set_teacherList([])
      }
    }

    const onClickUpload = (e) => {
    }

    const onChangeUpload = (e) => {
      const files = Array.from(e.target.files)
      files.forEach(f => printVariable(f.name))
      set_files(files)
    }

    useEffect(() => {
      set_teacherList(activeRow.smstId)
    }, [])

    const label = { inputProps: { "aria-label": "Checkbox demo" } }

    return (
      <Container component='main' maxWidth='lg'>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
          }}>
          <Typography component='h1' variant='h5'>
            기본정보
          </Typography>
          <Boxs component='form' noValidate sx={{ mt: 3 }}>
            <FormControl component='fieldset' variant='standard' fullWidth>
              <Grid container spacing={2}>
                {fields.map((col, index) => {
                  if (col.visible) {
                    if (col.type === "select") {
                      return (
                        <Grid item xs={xs} key={col.field}>
                          <FormControl fullWidth>
                            <InputLabel>{col.placeholder}</InputLabel>
                            <Select
                              required
                              value={activeRow[col.field]}
                              label={activeRow[col.placeholder]}
                              name={col.field}
                              onChange={async (e) => {
                                if (col.field === "smstId") {
                                  set_teacherList(e.target.value)
                                }
                                handleChange(e)
                              }}
                              size='small'>
                              {col.field === "userId"
                                ? teacherList.map((l) => {
                                  return (
                                    <MenuItem value={l.id}>{l.name}</MenuItem>
                                  )
                                })
                                : col.selList.map((l) => {
                                  return (
                                    <MenuItem value={l.id}>{l.name}</MenuItem>
                                  )
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                      )
                    } else if (col.type === "textarea") {
                      return (
                        <Grid item xs={12} key={col.field}>
                          <TextField
                            rows={5}
                            fullWidth
                            required
                            name={col.field}
                            label={col.placeholder}
                            value={activeRow[col.field]}
                            onChange={handleChange}
                            multiline
                          />
                        </Grid>
                      )
                    } else {
                      return (
                        <Grid item xs={xs} key={col.field}>
                          <TextField
                            size='small'
                            required
                            fullWidth
                            name={col.field}
                            label={col.placeholder}
                            value={activeRow[col.field]}
                            onChange={handleChange}
                          />
                        </Grid>
                      )
                    }
                  }
                })}
              </Grid>
            </FormControl>
            <FormHelperTexts>{registerError}</FormHelperTexts>
          </Boxs>

          <Typography component='h1' variant='h5'>
            요일
          </Typography>
          <Grid container spacing={0}>
            {weekCodeList.map((s, index) => {
              return (
                <Fragment>
                  <Grid item xs={4}>
                    <FormControlLabel
                      key={s.id}
                      control={
                        <Checkbox
                          color='primary'
                          onChange={(e) => {
                            onChangeWeek(s.id, e)
                          }}
                          checked={
                            activeRow.weekCodeList.find((s2) => s2.id === s.id)
                              ? true
                              : false
                          }
                        />
                      }
                      label={s.name}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"ko"}>
                      <TimePicker
                        label={"시작시간"}
                        ampm={false}
                        minutesStep={10}
                        inputFormat={"HH:mm"}
                        value={
                          activeRow.lschList.find((d) => d.weekCode === s.code)[
                          "startTime"
                          ]
                        }
                        onChange={(newValue) => {
                          const d = moment(new Date(newValue)).format(
                            dateFormat
                          )
                          activeRow.lschList.find((d) => d.weekCode === s.code)[
                            "startTime"
                          ] = d
                          handleChange()
                        }}
                        renderInput={(params) => (
                          <TextField size='small' {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={4}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"ko"}>
                      <TimePicker
                        label={"종료시간"}
                        ampm={false}
                        minutesStep={10}
                        inputFormat={"HH:mm"}
                        value={
                          activeRow.lschList.find((d) => d.weekCode === s.code)[
                          "endTime"
                          ]
                        }
                        onChange={(newValue) => {
                          const d = moment(new Date(newValue)).format(
                            dateFormat
                          )
                          activeRow.lschList.find((d) => d.weekCode === s.code)[
                            "endTime"
                          ] = d
                          handleChange()
                        }}
                        renderInput={(params) => (
                          <TextField size='small' {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Fragment>
              )
            })}
          </Grid>
          <Typography component='h1' variant='h5' sx={{ mt: 2 }}>
            대상 학년
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {ltgList.map((l) => {
                return (
                  <FormControlLabel
                    key={l.grade}
                    control={
                      <Checkbox
                        color='primary'
                        onChange={(e) => {
                          onChangeGrade(l.grade, e)
                        }}
                        checked={
                          activeRow.ltgList.find((l2) => l2.grade === l.grade)
                            ? true
                            : false
                        }
                      />
                    }
                    label={l.grade}
                  />
                )
              })}
            </Grid>
          </Grid>

          <Typography component='h1' variant='h5' sx={{ mt: 2 }}>
            첨부 파일
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {files.map((it) => {
                return (
                  <div>
                    <div>
                      {/* <img src={URL.createObjectURL(file)} alt={file.name} /><br/> */}
                    </div>
                    <div>{it.name}</div>
                  </div>
                )
              })}
            </Grid>
          </Grid>

          <input
            onChange={onChangeUpload}
            accept='image/*'
            style={{ display: "none" }}
            id='raised-button-file'
            multiple
            type='file'
          />
          <label htmlFor='raised-button-file'>
            <Button
              variant='contained'
              color='primary'
              size='small'
              component='span'
              onClick={onClickUpload}>
              파일
            </Button>
          </label>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={onSubmit}
            sx={{ mt: 1, width: 100, mb: 10 }}>
            저장
          </Button>
        </Box>
      </Container>
    )
  }

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    const size = window
      .getComputedStyle(inputRef.current, null)
      .getPropertyValue("font-size")

    set_fontSize(size)
  }, [])

  const dg_title = "강좌 정보"
  const memo_DgContent = useMemo(() => {
    return <DgContent />
  }, [record, detailScreen])
  if (dataList != null) {
    return (
      <div ref={inputRef}>
        <MyDialog
          title={dg_title}
          component={memo_DgContent}
          dialogHandler={dgHandler}
          callback={() => {
            set_detailScreen(false)
          }}
        />
        <MyDialog
          title={dg_title}
          component={memo_DgContent}
          dialogHandler={dgHandler}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Typography component='h1' variant='h5' align={"center"}>
            강좌 관리
          </Typography>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant='contained'
            color='primary'
            size='small'
            onClick={() => {
              onCreate()
            }}>
            생성
          </Button>
        </div>

        <div style={{ paddingTop: 20 }}>
          <MUITable>
            <MyTableHead>
              <TableRow>
                {fields.map((col, index2) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index2} size='small' key={col.field}>
                        {col.placeholder}
                        {col.canSrch ? (
                          <Fragment>
                            <br />
                            <TextField
                              label=''
                              variant='outlined'
                              size='small'
                              inputProps={{
                                style: {
                                  fontSize: "0.875em",
                                  padding: 5,
                                  backgroundColor: "#fff",
                                },
                              }}
                              value={terms[col.field]}
                              onChange={(e) => {
                                const newTerms = { ...terms }
                                newTerms[col.field] = e.target.value
                                set_terms(newTerms)
                              }}
                            />
                          </Fragment>
                        ) : (
                          <Fragment>
                            <br />
                            <br />
                          </Fragment>
                        )}
                      </TableCell>
                    )
                  }
                })}
                <TableCell size='small'>
                  <br />
                  <FlatButton
                    size='small'
                    variant='contained'
                    style={{ marginRight: 5 }}
                    color='primary'
                    onClick={onSearch}>
                    검색
                  </FlatButton>
                  <FlatButton
                    size='small'
                    variant='contained'
                    color='primary'
                    onClick={onClear}>
                    지우기
                  </FlatButton>
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {Object.keys(dataList).map((smstId) => {
                return (
                  <Fragment>
                    <TableRow>
                      <TableCell rowSpan={dataList[smstId].length + 1}>
                        {dataList[smstId].length > 0
                          ? dataList[smstId][0].smstName
                          : "데이터 없음"}
                      </TableCell>
                    </TableRow>
                    {dataList[smstId].map((row, index) => {
                      return (
                        <TableRow
                          onClick={() => {
                            set_selIdx(index)
                            set_record(row)
                          }}>
                          {fields.map((col, index2) => {
                            if (col.visible && col.field !== "smstName") {
                              return (
                                <TableCell key={index2} size='small'>
                                  {row[col.field]}
                                </TableCell>
                              )
                            }
                          })}
                          <TableCell size='small'>
                            <FlatButton
                              variant='outlined'
                              size='small'
                              style={{ marginRight: 5 }}
                              onClick={() => onDetail(smstId, row.id)}>
                              일정생성
                            </FlatButton>
                            <FlatButton
                              variant='outlined'
                              size='small'
                              style={{ marginRight: 5 }}
                              onClick={() => onDetail(smstId, row.id)}>
                              보기
                            </FlatButton>
                            <FlatButton
                              variant='outlined'
                              color='error'
                              size='small'
                              onClick={() => onDelete(row.id)}>
                              삭제
                            </FlatButton>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </Fragment>
                )
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
                  colSpan={visibleColumns.length + 1}
                  count={totalCount}
                  rowsPerPage={pageInfo.pageSize}
                  page={pageInfo.pageNum}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  labelDisplayedRows={({ from, to, count }) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }}
                  labelRowsPerPage={"페이지당 갯수"}
                />
              </TableRow>
            </TableFooter>
          </MUITable>
          {renderIndicator()}

        </div>
      </div>
    )
  }
}

export default LecturePage
